import { z } from "zod";
import { UsuarioPublicoSchema } from "./usuario.schema.js";
/** Usuario público + estado de 2FA, tal como lo devuelve el módulo de auth. */
export const UsuarioSesionSchema = UsuarioPublicoSchema.extend({
    totpHabilitado: z.boolean(),
    notificarDomicilios: z.boolean(),
    notificarSolicitudesQr: z.boolean(),
    notificarPagosBancarios: z.boolean().optional(),
    // CAJERO restringido a solo cobrar mesas + abrir/cerrar caja -- el
    // frontend lo usa para ocultar Venta Rápida y Tomar Pedido.
    soloCobroYCaja: z.boolean().optional(),
});
export const LoginSchema = z.object({
    usuario: z.string().min(1, "Ingresa tu usuario"),
    password: z.string().min(1, "Ingresa tu contraseña"),
});
export const LoginPinSchema = z.object({
    usuario: z.string().min(1),
    pin: z
        .string()
        .regex(/^\d{4,6}$/, "El PIN debe tener entre 4 y 6 dígitos"),
});
const CODIGO_TOTP = z.string().regex(/^\d{6}$/, "El código debe tener 6 dígitos");
export const Verificar2faSchema = z.object({
    tokenTemporal: z.string().min(1),
    codigo: CODIGO_TOTP,
});
export const Activar2faSchema = z.object({
    codigo: CODIGO_TOTP,
});
/** Variantes "con token": se usan cuando la nube obliga a configurar 2FA antes de completar el login (sección 4). */
export const Generar2faConTokenSchema = z.object({
    tokenTemporal: z.string().min(1),
});
export const Activar2faConTokenSchema = z.object({
    tokenTemporal: z.string().min(1),
    codigo: CODIGO_TOTP,
});
export const Desactivar2faSchema = z.object({
    password: z.string().min(1),
});
/** Sesión completa: token de acceso (memoria) + refresh token (cookie httpOnly, no viaja en el body). */
export const SesionSchema = z.object({
    accessToken: z.string(),
    usuario: UsuarioSesionSchema,
});
export const LoginRespuestaSchema = z.union([
    SesionSchema,
    z.object({ requiere2fa: z.literal(true), tokenTemporal: z.string() }),
    z.object({ requiereConfiguracion2fa: z.literal(true), tokenTemporal: z.string() }),
]);
export const Generar2faRespuestaSchema = z.object({
    secreto: z.string(),
    otpauthUrl: z.string(),
    qrCodeDataUrl: z.string(),
});
//# sourceMappingURL=auth.schema.js.map